<template>
<b-card>
  <!-- modal begin -->
  <div class="card-header">
    <ul class="nav nav-pills card-header-pills">

      <!-- <li class="nav-item"> -->
        <!-- <a class="nav-link disabled">eKeys</a> -->
      <!-- </li> -->
      <li class="nav-item">
        <div>
          <b-button @click="modalShow = !modalShow" style="background-color:orange; color:#fff;">
            <i class="fa fa-plus-circle"></i> Share
          </b-button>
          <b-modal v-model="modalShow" ok-only ok-variant="secondary" ok-title="Close">
            <ekey-form :lockId=lockId></ekey-form>
          </b-modal>
        </div>
      </li>
    </ul>
  </div>

  <!-- modal end -->
  <b-table responsive="sm" :items="ekeys" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
    <template slot="name" slot-scope="data">
      <small class="text-muted ng-binding">{{data.item.name}}</small>
      <div v-if="data.item.endDate > 0"><img src="/static/img/temporary.png" width="25px" style="margin-bottom: 5px;"></div>
      <div v-if="data.item.endDate === 0"><img src="/static/img/perpetual.png" width="25px" style="margin-bottom: 5px;"></div>
    </template>
    <template slot="userinfo" slot-scope="data">
      <i class="icon-phone"></i>
      <small class="text-muted ng-binding">
        {{data.item.username}}
        <a :href="whatsapp(data.item.username)" :target="data.item.username"><i class="fa fa-whatsapp"></i></a>
      </small><br/>
      <i class="icon-envelope"></i> <a :href="mailto(data.item.email)"><small class="text-muted ng-binding">{{data.item.email}}</small></a>
    </template>
    <template slot="createdBy" slot-scope="data">
      <i class="icon-person" v-if="data.item.createdBy"></i> <small class="text-muted ng-binding">{{data.item.createdBy}}</small><br/>
      <i class="icon-envelope" v-if="data.item.creatorEmail"></i> <a :href="mailto(data.item.creatorEmail)"><small class="text-muted ng-binding">{{data.item.creatorEmail}}</small></a>
    </template>
    <template slot="startEndDate" slot-scope="data">
      <small class="text-muted ng-binding">
        <div>
          Created: <i class="icon-calendar"></i>  {{(new Date(data.item.createdDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
        </div>
        <div style="display: table-cell;" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) > 0">
          Period: <i class="icon-calendar"></i>  <small class="text-muted ng-binding">{{(new Date(data.item.startDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}</small>
        </div>
        <small class="text-muted ng-binding" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) < 0" style="color:red !important;display: table-cell;">
           Period: &#8734;
          </div>
        </small>
         <small class="text-muted ng-binding" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) > 0" style="display: table-cell;">
            <strong> - </strong> {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
          </small>
      </small>

      <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="data.item.percentageVal > 25">
        <div class="progress-bar bg-success" role="progressbar" :style="data.item.percentage" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>

      <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="data.item.percentageVal < 25 && data.item.percentageVal > 5">
        <div class="progress-bar bg-warning" role="progressbar" :style="data.item.percentage" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>

      <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="data.item.percentageVal <= 5">
        <div class="progress-bar bg-danger" role="progressbar" :style="data.item.percentage" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </template>

    <template slot="action" slot-scope="data">
      <div style="width: 100%; display: table;">
        <div style="display:table-cell;margin-right: 5px; float: left;">
          <b-button type="button" variant="primary" @click.stop="showModal(modalId(data.item.keyId), $event.target)"  v-if="data.item.keyStatus != '110401'">
            <i class="fa fa-edit"></i>
            Edit
          </b-button>
        </div>
        <div style="display:table-cell;float: left;">
          <b-button type="button" variant="danger" @click.stop="showModal(modalDeleteId(data.item.keyId), $event.target)" v-if="data.item.keyStatus != '110401'">
            <i class="fa fa-trash-o"></i>
            Delete
          </b-button>
        </div>
      </div>
    </template>

  </b-table>
  <nav>
    <b-pagination :total-rows="getRowCount(ekeys)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
  </nav>

  <div v-for="ekey in ekeys" :key="ekey.id">
    <b-modal ok-only ok-variant="secondary" ok-title="Cancel" :id="modalId(ekey.keyId)">
      <ekey-edit-form :ekeyId=ekey.keyId :ekey=ekey :modalId="modalId(ekey.keyId)" :lockId="ekey.lockId"></ekey-edit-form>
    </b-modal>

    <b-modal :id="modalDeleteId(ekey.keyId)" @ok="handleOk(ekey.keyId, modalDeleteId(ekey.keyId), $event.target)" centered>
      <div class="modal-window">
        <div class="alert alert-danger">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <p>Are you sure you want to delete the ekey for user: <br/> <strong>{{ ekey.name }}</strong> ?</p>
            </li>
          </ul>
        </div>

      </div>
    </b-modal>
  </div>
</b-card>
</template>

<script>
import EkeyForm from '@/views/base/haus/EkeyForm'
import EkeyEditForm from '@/views/base/haus/EkeyEditForm'

let qs = require('qs')

const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/locks/listGuest'
const API_DELETE = BASE + '/api/keys/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    pageSize: 25
  }
  let res = await postdata(API, parameters)
  let result = res.list
  return result
}

async function deleteItem (keyId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    keyId: keyId
  }
  let res = await postdata(API_DELETE, parameters)
  return res
}

export default {
  name: 'ekey-list',
  components: {
    EkeyForm,
    EkeyEditForm
  },
  data: () => {
    return {
      modalShow: false,
      modalShowEdit: false,
      modalDelete: false,
      ekeys: [],
      fields: {
        name: {
          label: 'Name'
        },

        userinfo: {
          label: 'User'
        },
        createdBy: {
          label: 'Created By'
        },
        startEndDate: {
          label: 'Period'
        },
        action: {
          label: 'Action'
        }
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.$route.params.lockId).then(response => {
      this.$data.ekeys = response
    })
    this.$root.$on('ekeylist', (dataEkeys) => {
      this.ekeys = dataEkeys
    })
    this.$root.$on('modalShow', (modalShow) => {
      this.modalShow = modalShow
    })
  },
  methods: {
    modalId (i) {
      return 'modal' + i
    },
    modalDeleteId (i) {
      return 'modaldelete' + i
    },
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    handleOk (id, modalId, button) {
      let lockId = this.$route.params.lockId
      deleteItem(id).then(response => {
        getData(lockId).then(response => {
          this.$data.ekeys = response
          this.$root.$emit('bv::hide::modal', modalId, button)
        })
      })
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/EkeyList.vue